import { css } from '@emotion/core';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Button from '../../shared/Button/Button';
import './NotFound.scss';
import { ImageDispatcher } from '../../shared/ImageDispatcher/ImageDispatcher';

let NotFound = props => {
  const getStyle = (primaryColor, uiVariantButton) => css`
    .title {
      color: ${primaryColor};
    }
    .btn {
      text-transform: none !important;
    }
  `;

  const goTo = path => {
    props.router.push(path);
  };

  return (
    <div
      className="not-found"
      css={getStyle(props.primaryColor, props.uiVariantButton)}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <h1 className="title">Oops!</h1>
        <h2
          style={{
            marginBottom: '1.5rem',
            marginTop: '0.5rem',
            fontSize: 18,
            fontWeight: 200,
          }}
        >
          questa pagina non esiste.
        </h2>
        <div style={{ display: 'flex', gap: '1.5rem' }}>
          <Button
            onClick={() => goTo('/')}
            className="btn btn-primary btn-thick"
          >
            Vai alla homepage
          </Button>
          <Button
            onClick={() => goTo('/prodotti-in-offerta')}
            className="btn btn-outline btn-thick"
          >
            Vai a tutti i prodotti
          </Button>
        </div>
        <ImageDispatcher
          src="/static/images/404.png"
          className="image"
          alt="Immagine relativa a Pagina non trovata"
        />
      </div>
    </div>
  );
};

NotFound = withRouter(NotFound);

const mapStateToProps = state => ({
  primaryColor: state.store.data.loghiTemplate.brandColor,
  uiVariantButton: state.store.data.uiVariants.buttons,
});

export default connect(mapStateToProps)(NotFound);
